import { render, staticRenderFns } from "./SiteCreate.vue?vue&type=template&id=3965f9a3&scoped=true"
import script from "./SiteCreate.vue?vue&type=script&lang=ts"
export * from "./SiteCreate.vue?vue&type=script&lang=ts"
import style0 from "./SiteCreate.vue?vue&type=style&index=0&id=3965f9a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965f9a3",
  null
  
)

export default component.exports